import { render } from "./edge.vue?vue&type=template&id=3006aa3e"
import script from "./edge.vue?vue&type=script&lang=js"
export * from "./edge.vue?vue&type=script&lang=js"

import "./edge.vue?vue&type=style&index=0&id=3006aa3e&lang=less"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__